export default __webpack_public_path__ + "static/media/plate_connect.6b2086ae.svg";